/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import {
  PAGE_URL_SIGNUP,
  PAGE_URL_TESTING,
  PAGE_URL_RESULT,
} from '../constants';

/* eslint-disable global-require */

// The top-level (parent) route
const routes = {
  path: '',

  // Keep in mind, routes are evaluated in order
  children: [
    {
      path: '',
      load: () => import(/* webpackChunkName: 'home' */ './home'),
    },
    {
      path: PAGE_URL_TESTING,
      load: () => import(/* webpackChunkName: 'testing' */ './testing'),
      children: [{ path: '/*' }],
    },
    {
      path: PAGE_URL_SIGNUP,
      load: () => import(/* webpackChunkName: 'result' */ './before'),
    },
    {
      path: PAGE_URL_RESULT,
      load: () => import(/* webpackChunkName: 'result' */ './result'),
    },
    // Wildcard routes, e.g. { path: '(.*)', ... } (must go last)
    {
      path: '(.*)',
      load: () => import(/* webpackChunkName: 'not-found' */ './not-found'),
    },
  ],

  async action({ next }) {
    // Execute each child route until one of them return the result
    const route = await next();

    // Provide default values for title, description etc.
    route.title = `${route.title || 'Определи свой психотип'}`;
    route.description = route.description || 'Получите подробное описание вашего психологического типа, и используйте свои сильные стороны, чтобы стать успешнее. Вы удивитесь точности результата.';
    route.keywords = ['психотип', 'mbti', 'тесты', 'майерс-бриггс', 'тип личности', 'психологический тип'];

    return route;
  },
};

// The error page is available by permanent url for development mode
if (__DEV__) {
  routes.children.unshift({
    path: '/error',
    action: require('./error').default,
  });
}

export default routes;



// WEBPACK FOOTER //
// ./src/routes/index.js